function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ROOM_CODES } from '@whitbread-eos/api';
import { Select, Switch } from '@whitbread-eos/atoms/ui';
import { useTranslation, formatIBAssetsUrl } from '@whitbread-eos/utils/server';
const defaultRoomType = ROOM_CODES.double;
const Room = ({ room, updateRoom, formLabels, roomNumber, roomsCount, roomId, icons, hasSeparator = false, removeRoom })=>{
    const { t } = useTranslation();
    const handleChildrenChange = (newValue)=>{
        if (newValue) {
            updateRoom(roomId, _object_spread_props(_object_spread({}, room), {
                children: newValue,
                roomType: ROOM_CODES.family
            }));
        } else {
            updateRoom(roomId, _object_spread_props(_object_spread({}, room), {
                children: newValue,
                roomType: defaultRoomType
            }));
        }
    };
    const handleAdultsChange = (newValue)=>{
        if (newValue === 1 && room.roomType === ROOM_CODES.twin || newValue > 1 && room.roomType === ROOM_CODES.single) {
            updateRoom(roomId, _object_spread_props(_object_spread({}, room), {
                adults: newValue,
                roomType: defaultRoomType
            }));
        } else {
            updateRoom(roomId, _object_spread_props(_object_spread({}, room), {
                adults: newValue
            }));
        }
    };
    const handleRoomTypeOptions = ()=>{
        if (!room.children) {
            if (room.adults === 1) {
                return [
                    {
                        value: ROOM_CODES.single,
                        displayValue: `${t('content.global.single')}`
                    },
                    {
                        value: ROOM_CODES.double,
                        displayValue: `${t('content.global.double')}`
                    },
                    {
                        value: ROOM_CODES.accessible,
                        displayValue: `${t('content.global.accessible')}`
                    }
                ];
            }
            if (room.adults > 1) {
                return [
                    {
                        value: ROOM_CODES.double,
                        displayValue: `${t('content.global.double')}`
                    },
                    {
                        value: ROOM_CODES.twin,
                        displayValue: `${t('content.global.twin')}`
                    },
                    {
                        value: ROOM_CODES.accessible,
                        displayValue: `${t('content.global.accessible')}`
                    }
                ];
            }
        }
        return [
            {
                value: ROOM_CODES.family,
                displayValue: `${t('content.global.family')}`
            }
        ];
    };
    const handleRoomTypeChange = (newValue)=>{
        updateRoom(roomId, _object_spread_props(_object_spread({}, room), {
            roomType: newValue
        }));
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: roomContainerStyle,
        "data-testid": `IB-Room-${roomNumber}`,
        children: [
            /*#__PURE__*/ _jsxs("span", {
                className: roomLabelStyle,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: roomStyle,
                        children: [
                            t('content.form.room'),
                            " ",
                            roomNumber
                        ]
                    }),
                    roomsCount > 1 && /*#__PURE__*/ _jsx("button", {
                        "data-testid": `IB-Remove-Room-${roomNumber}-Button`,
                        className: removeRoomStyle,
                        onClick: ()=>removeRoom(roomId),
                        children: t('content.form.removeRoom')
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-2 w-full",
                        children: [
                            /*#__PURE__*/ _jsx(Select, {
                                value: room.adults,
                                onOptionChange: (newValue)=>handleAdultsChange(newValue),
                                triggerIcon: formatIBAssetsUrl(formLabels === null || formLabels === void 0 ? void 0 : formLabels.guestIcon),
                                triggerContent: '',
                                label: t('content.global.adultsLabel'),
                                arrowIcon: formatIBAssetsUrl(icons['icon.chevron.down']),
                                testId: `IB-RoomOccupancy-Adults-Dropdown-${roomNumber}`,
                                options: [
                                    {
                                        value: 1,
                                        displayValue: `1 ${t('content.global.adult')}`
                                    },
                                    {
                                        value: 2,
                                        displayValue: `2 ${t('content.global.adults')}`
                                    }
                                ],
                                showValueInstead: true
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: helperStyle,
                                children: t('content.form.adultsHelperText')
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-2 w-full",
                        children: [
                            /*#__PURE__*/ _jsx(Select, {
                                value: room.children,
                                onOptionChange: (newValue)=>handleChildrenChange(newValue),
                                triggerIcon: formatIBAssetsUrl(formLabels === null || formLabels === void 0 ? void 0 : formLabels.guestIcon),
                                triggerContent: '',
                                label: t('content.global.childrenLabel'),
                                arrowIcon: formatIBAssetsUrl(icons['icon.chevron.down']),
                                testId: `IB-RoomOccupancy-Children-Dropdown-${roomNumber}`,
                                options: [
                                    {
                                        value: 0,
                                        displayValue: `0 ${t('content.global.children')}`
                                    },
                                    {
                                        value: 1,
                                        displayValue: `1 ${t('content.global.child')}`
                                    },
                                    {
                                        value: 2,
                                        displayValue: `2 ${t('content.global.children')}`
                                    }
                                ],
                                showValueInstead: true
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: helperStyle,
                                children: t('content.form.childrenHelperText')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: cotContainerStyle,
                children: [
                    /*#__PURE__*/ _jsx(Switch, {
                        checked: room.shouldIncludeCot,
                        onCheckedChange: (newValue)=>updateRoom(roomId, _object_spread_props(_object_spread({}, room), {
                                shouldIncludeCot: newValue
                            })),
                        "data-testid": `IB-shouldIncludeCot-Switch-${roomNumber}`
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: cotLabelContainerStyle,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: cotLabelStyle,
                                children: t('content.form.includeCot')
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: cotHelperStyle,
                                children: t('content.form.cotLimit')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Select, {
                value: room.roomType,
                onOptionChange: (newValue)=>handleRoomTypeChange(newValue),
                triggerIcon: formatIBAssetsUrl(formLabels === null || formLabels === void 0 ? void 0 : formLabels.guestIcon),
                triggerContent: '',
                label: t('content.form.roomType'),
                arrowIcon: formatIBAssetsUrl(icons['icon.chevron.down']),
                testId: `IB-RoomOccupancy-RoomType-${roomNumber}`,
                options: handleRoomTypeOptions()
            }),
            hasSeparator && /*#__PURE__*/ _jsx("div", {
                className: separatorStyle
            })
        ]
    });
};
export default Room;
const roomContainerStyle = 'flex flex-col gap-6';
const roomLabelStyle = 'flex justify-between';
const helperStyle = 'text-[0.813rem] ml-4 text-darkGrey1';
const cotContainerStyle = 'flex gap-4 items-center';
const cotLabelContainerStyle = 'flex gap-2 items-center';
const cotLabelStyle = 'flex items-center font-semibold';
const cotHelperStyle = 'flex items-center text-sm';
const separatorStyle = 'bg-lightGrey4 w-full h-[1px]';
const removeRoomStyle = 'text-sm font-medium text-secondaryColor underline';
const roomStyle = 'text-lg font-semibold text-darkGrey1';
